import { Component, ElementRef } from '@angular/core';

import { UsageCounter, UserStatistics } from '../../../../interfaces/UserInterfaces';
import { NameIndex, NameValue, Feedback } from '../../../../interfaces/WidgetInterfaces';
import { DataSet } from '../../../../interfaces/DisplayInterfaces';

import { BaseWidget } from '../../BaseWidget/BaseWidget.component';
import { LogEntry } from '../../../../services/AppStateService';
import { DataSeriesMapping } from 'highcharts';

import { DisplayStateService } from '../../../../services/DisplayStateService';
import { AppStateService } from '../../../../services/AppStateService';
import { WebPlatformApiService } from '../../../../services/WebPlatformApiService';
import { ClientSettingsService } from '../../../../services/ClientSettingsService';
import * as _ from 'lodash';



@Component({
  selector: 'app-diagnostics',
  template: `<tabset>
    <tab heading = "Individual usage Statistics">
        <table class="table table-sm table-striped">
          <thead>
            <tr>
              <th>Type</th>
              <th>Key</th>
              <th>Count</th>
              <th>Last</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let stat of userStatistics.widgetUsageStatistics">
              <td>widget usage</td>
              <td>{{stat.key}}</td>
              <td>{{stat.count}}</td>
              <td>{{stat.lastUsage}}</td>
            </tr>

            <tr *ngFor="let stat of userStatistics.applicationUsageStatistics">
              <td>app counters</td>
              <td>{{stat.key}}</td>
              <td>{{stat.count}}</td>
              <td>{{stat.lastUsage}}</td>
            </tr>

            <tr *ngFor="let stat of userStatistics.sideNavUsageStatistics">
              <td>side nav usage</td>
              <td>{{stat.key}}</td>
              <td>{{stat.count}}</td>
              <td>{{stat.lastUsage}}</td>
            </tr>

             <tr *ngFor="let stat of userStatistics.dataPolicyUsageStatistics">
              <td>data policy</td>
              <td>{{stat.key}}</td>
              <td>{{stat.count}}</td>
              <td>{{stat.lastUsage}}</td>
            </tr>

          </tbody>
        </table>
    </tab>
    <tab heading="User entitled designs">
        <app-platform-table [Dataset]="designIdDataSet" [SortAndfilterLocally]="true"></app-platform-table>
    </tab>
    <tab heading="Widget Registration and Layout">
    <table class="table table-sm table-striped">
          <thead>
            <tr>
              <th>user/pref</th>
              <th>key</th>
              <th>width</th>
              <th>height</th>
              <th>widgets</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let stat of widgetGroups">
              <td>user</td>
              <td>{{stat[0]}}</td>
              <td>{{stat[1]}}</td>
              <td>{{stat[2]}}</td>
              <td>{{stat[3]}}</td>
            </tr>
            <tr *ngFor="let stat of preferredWidgetGroups">
              <td>preferred</td>
              <td>{{stat[0]}}</td>
              <td>{{stat[1]}}</td>
              <td>{{stat[2]}}</td>
              <td>{{stat[3]}}</td>
            </tr>

          </tbody>
        </table>
    </tab>

    <tab heading="Settings">
      <table class="table table-sm table-striped">
        <tr *ngFor="let setting of settings">
          <td>{{setting.name}}</td>
          <td>{{setting.value}}</td>
        </tr>
      </table>
    </tab>

    <tab heading="Versions">
      <table class="table table-sm table-striped">
        <tr *ngFor="let version of versions">
          <td>{{version.name}}</td>
          <td>{{version.value}}</td>
        </tr>
      </table>
    </tab>

    <tab heading="Activity Logs">
      <table class="table table-sm table-striped">
        <thead>
          <tr>
            <th>ms</th>
            <th>message</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let log of entries" [ngClass]="getLogClass(log.level)">
            <td style="padding: 2px">{{log.milliseconds}}</td>
            <td style="padding: 2px">{{log.Message}}</td>
          </tr>
        </tbody>
      </table>
    </tab>
    <tab heading="Server cache hit logs">
      <app-server-hit-logs></app-server-hit-logs>
    </tab>
    <tab heading="usage logs">

      <button *ngFor="let nv of buttons"  class="btn {{IsActive(nv.value)}}" (click)="SelectStatsType(nv.value)">{{nv.name}}</button>

      <table class="table table-sm table-striped">
        <thead><tr> <th>Item</th><th>Count</th> </tr></thead>
        <tbody>
          <tr *ngFor="let ni of aggregateStats">
            <td>{{ni.name}}</td>
            <td>{{ni.index}}</td>
          </tr>
        </tbody>
      </table>
    </tab>
    <tab heading="all user counts">


      <button *ngFor="let nv of buttons"  class="btn {{IsActive(nv.value)}}" (click)="SelectStatsType(nv.value)">{{nv.name}}</button>

      <input style="width: 70%;" type="text" class="form-control" [ngModel]="userFilter" (ngModelChange)="onFilterChange($event)" placeholder="User filter">

      <table class="table table-sm table-striped">
        <thead>
          <tr>
            <th *ngFor="let column of userDataTable.columns">{{column}}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of userDataTable.data">
            <td *ngFor="let cell of row">{{cell}}</td>
          </tr>
        </tbody>
      </table>

    </tab>

    <tab heading="User Feedback">

        <table class="table table-hover" *ngIf="feedbacks">
          <thead>
            <tr>
              <th>#</th>
              <th>Type</th>
              <th>Widget</th>              
              <th>Title</th>
              <th>Description</th>
              <th>Raised By</th>
              <!-- <th>Actions</th> -->
            </tr>
          </thead>
          <tbody>

            <tr *ngFor="let fb of feedbacks; let j = index">
              <td>{{j+1}}</td>
              <td>{{fb.type}}</td>
              <td>{{fb.widget}}</td>
              <td>{{fb.title}}</td>
              <td>{{fb.desc}}</td>
              <td>{{fb.userName}}</td>
              <!-- <td>
                <div class="btn-group" role="group">
                  <button id="btnGroupVerticalDrop1" type="button" class="btn btn-secondary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true"
                    aria-expanded="false">
                             ... Under construction ...
                            </button>
                  <div class="dropdown-menu" aria-labelledby="btnGroupVerticalDrop1">
                    <a class="dropdown-item" href="#">Add to Jira</a>
                    <a class="dropdown-item" href="#">Report</a>
                    <a class="dropdown-item" href="#">Discard</a>
                    <a class="dropdown-item" href="#">Add Comment</a>
                  </div>
                </div>
              </td> -->
            </tr>
          </tbody>
        </table>
    </tab>
</tabset>
`,
  styles: [`.btn{
    padding:0px
}`]
})
export class DiagnosticsComponent extends BaseWidget {

  entries: LogEntry[] = [];
  aggregateStats: NameIndex[] = [];
  userStatistics: UserStatistics;
  userStatisticsList: UserStatistics[];
  designIdDataSet: DataSet;
  userDataTable: DataSet = { columns: [], data: [] };
  selectedStatsType = 'widget';
  userFilter = '';

  settings: NameValue[] = [];
  versions: NameValue[] = [];
  widgetGroups: string[][] = [];
  preferredWidgetGroups: string[][] = [];
  feedbacks: Feedback[] = [];

  buttons: NameValue[] = [
    { name: 'Widgets', value: 'widget' },
    { name: 'App', value: 'app' },
    { name: 'Data', value: 'data' },
    { name: 'Side Nav', value: 'side nav' },
  ];

  constructor(
    protected element: ElementRef,
    protected clientSettingsService: ClientSettingsService,
    protected displayStateService: DisplayStateService,
    protected appStateService: AppStateService,
    protected webPlatformApiService: WebPlatformApiService) {
      super(element, clientSettingsService, displayStateService, appStateService, webPlatformApiService);
    }

  onFilterChange(newValue: string) {
    this.userFilter = newValue.toLowerCase();
    this.CreateStats();

  }

  getLogClass(level: number) {
    // 1 = error, 2 = warning, 3 = major, 4 = minor, 5 = trace
    if (level < 1)   { return 'danger';  } else
    if (level === 1) { return 'error';   } else
    if (level === 2) { return 'warning'; } else
    if (level === 3) { return 'primary'; } else {
    return 'info'; }
  }

  IsActive(type: string): string {
    return this.selectedStatsType === type ? 'btn-active' : 'btn-secondary';
  }
  SelectStatsType(type: string) {
    if (this.selectedStatsType !== type) {
      this.selectedStatsType = type;
      this.CreateStats();
    }
  }

  onInitialize() {

    this.settings.push({name: 'Redirect URL suffix', value: this.clientSettingsService.RedirectUrlSuffix});
    this.settings.push({name: 'Middle layer API', value: this.clientSettingsService.WebApiUrl});
    this.settings.push({name: 'Application Log Level', value: this.clientSettingsService.AppLogLevel.toString()});
    this.settings.push({name: 'Console Log level', value: this.clientSettingsService.ConsoleLogLevel.toString()});
    this.settings.push({name: 'Skip Authentication', value: this.clientSettingsService.SkipAuthentication.toString()});
    this.versions = this.clientSettingsService.VersionInfo;
    this.webPlatformApiService.GetServerConfigurationSettings().subscribe( list => {
      list.forEach(s => { this.settings.push( {name: s.Key, value: s.Value } ); });
    });

    this.Refresh();
    this.prepareFeedback();

  }

  Refresh() {
    this.entries = [... this.appStateService.appState.rollingLogEntries];
    this.userStatistics = this.displayStateService.appState.current.userStatistics;
    this.webPlatformApiService.GetAllUserStats().subscribe(list => {
      this.userStatisticsList = list;
      this.CreateStats();
    });

    this.webPlatformApiService.GetUserDesigns().subscribe( list => {
      this.designIdDataSet =  { columns: ['Design ID'], data: [] };
      this.designIdDataSet.data = [];
      list.map( d => this.designIdDataSet.data.push([d]));
    });

    this.CreateWidgetGroupData();
  }

  CreateWidgetGroupData() {
    const userStats = this.displayStateService.appState.current.userStatistics;

    this.widgetGroups = [];
    if (userStats && userStats.widgetRegistration && userStats.widgetRegistration.groupedWidgets) {
      userStats.widgetRegistration.groupedWidgets
        .sort( (a, b) => a.contextKey.localeCompare(b.contextKey))
        .forEach( gw => {
          this.widgetGroups.push([gw.contextKey, gw.heightSpec, gw.widthSpec, gw.widgets.map(w => w.name).join(',') ]);
        });
    }

    this.preferredWidgetGroups = [];
    this.displayStateService.GetAllPreferredSettings()
      .sort( (a, b) => a.contextKey.localeCompare(b.contextKey))
      .forEach( gw => {
        this.preferredWidgetGroups.push([gw.contextKey, gw.heightSpec, gw.widthSpec, gw.widgets.map(w => w.name).join(',') ]);
      });
  }
  
  StatsPerCollection(counter: UsageCounter[], nameIndexList: NameIndex[], prefix: string) {
    if (counter) {
      counter.forEach(us => {
        const key = `${us.key}`;
        nameIndexList.push({ name: key, index: us.count });
        let thisNi = this.aggregateStats.find(ni => ni.name === key);
        if (thisNi === undefined) {
          thisNi = { name: key, index: 0 };
          this.aggregateStats.push(thisNi);
        }
        thisNi.index += us.count;
      });
    }
  }

  CreateStats() {
    this.aggregateStats = [];
    this.userDataTable = { columns: [], data: [] };
    const userStatsCollections: StatsCollection[] = [];

    this.userStatisticsList.forEach(stats => {

      if (!this.userFilter || stats.userName.toLowerCase().indexOf(this.userFilter) > -1) {
        const thisStatsCollection = new StatsCollection(stats.userName);
        userStatsCollections.push(thisStatsCollection);

        switch (this.selectedStatsType) {
          case 'data':
            this.StatsPerCollection(stats.dataPolicyUsageStatistics, thisStatsCollection.stats, 'data');
            break;
          case 'app':
            this.StatsPerCollection(stats.applicationUsageStatistics, thisStatsCollection.stats, 'app');
            break;
          case 'side nav':
            this.StatsPerCollection(stats.sideNavUsageStatistics, thisStatsCollection.stats, 'side nav');
            break;
          default:
            this.selectedStatsType = 'widget';
            this.StatsPerCollection(stats.widgetUsageStatistics, thisStatsCollection.stats, 'widget');
        }
      }
    });

    this.aggregateStats = this.aggregateStats.sort((a, b) => { return b.index - a.index; });
    this.userDataTable.columns = this.aggregateStats.map(a => a.name);
    userStatsCollections.forEach(sc => {

      const row: string[] = [sc.user];
      this.userDataTable.columns.forEach(c => {
        const found = sc.stats.find(x => x.name === c);
        row.push(found === undefined ? '' : found.index.toString());
      });
      this.userDataTable.data.push(row);
    });

    this.userDataTable.columns.splice(0, 0, 'user');
  }

  private prepareFeedback() {
    this.webPlatformApiService.GetMongoDocs('Feedback', {}).subscribe((data: any[]) => {
      _.forEach(data, (feedbacksPerWidget: any) => {
        const payload = feedbacksPerWidget['Payload'];
        _.forEach(payload, (feedback: Feedback) => {
          feedback['widget'] = feedbacksPerWidget['key'];
          this.feedbacks.push(feedback);
        });
      });
    });
  }
}

class StatsCollection {

  user: string;
  stats: NameIndex[];

  constructor(user: string) {
    this.user = user;
    this.stats = [];
  }
}
